import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { environment } from '@env/environment.qa';
import { LegacyLink } from '@app/shared/models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'ic-auth-footer',
    templateUrl: './auth-footer.component.html',
    styleUrls: ['./auth-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class AuthFooterComponent implements OnInit {

    youtubeUrl: string = '';

    protected termsUrl = LegacyLink.TermsOfUse;
    protected privacyLink = LegacyLink.PrivacyNPolicy;
    protected helpLink = LegacyLink.Help;

    ngOnInit() {
        this.youtubeUrl = environment.youtubeUrl;
    }
}
